var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCobrancasIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3507 10.9551H17.5834C16.6722 10.9551 15.9336 11.6937 15.9336 12.6049V31.3497C15.9336 32.261 16.6722 32.9995 17.5834 32.9995H31.3507C32.262 32.9995 33.0005 32.261 33.0005 31.3497V12.6049C33.0005 11.6937 32.262 10.9551 31.3507 10.9551Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4591 24.1116C21.1646 24.1116 20.9258 23.8728 20.9258 23.5783C20.9258 23.2837 21.1646 23.0449 21.4591 23.0449",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.459 24.1116C21.7535 24.1116 21.9923 23.8728 21.9923 23.5783C21.9923 23.2837 21.7535 23.0449 21.459 23.0449",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4591 29.1028C21.1646 29.1028 20.9258 28.864 20.9258 28.5695C20.9258 28.2749 21.1646 28.0361 21.4591 28.0361",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.459 29.1028C21.7535 29.1028 21.9923 28.864 21.9923 28.5695C21.9923 28.2749 21.7535 28.0361 21.459 28.0361",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4904 24.1116C27.1958 24.1116 26.957 23.8728 26.957 23.5783C26.957 23.2837 27.1958 23.0449 27.4904 23.0449",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4902 24.1116C27.7848 24.1116 28.0236 23.8728 28.0236 23.5783C28.0236 23.2837 27.7848 23.0449 27.4902 23.0449",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4904 29.1028C27.1958 29.1028 26.957 28.864 26.957 28.5695C26.957 28.2749 27.1958 28.0361 27.4904 28.0361",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4902 29.1028C27.7848 29.1028 28.0236 28.864 28.0236 28.5695C28.0236 28.2749 27.7848 28.0361 27.4902 28.0361",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80092 6.33327C5.50636 6.33327 5.26758 6.09449 5.26758 5.79993C5.26758 5.50538 5.50636 5.2666 5.80092 5.2666",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 6.33327C6.09534 6.33327 6.33412 6.09449 6.33412 5.79993C6.33412 5.50538 6.09534 5.2666 5.80078 5.2666",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 18.0667H3.13337C2.56757 18.0667 2.02493 17.8419 1.62485 17.4419C1.22476 17.0418 1 16.4991 1 15.9333V3.13333C1 2.56754 1.22476 2.02491 1.62485 1.62484C2.02493 1.22476 2.56757 1 3.13337 1H26.6004C27.1662 1 27.7089 1.22476 28.109 1.62484C28.5091 2.02491 28.7338 2.56754 28.7338 3.13333V6.68889",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1685 11.6807C10.7981 11.0254 10.6022 10.2859 10.5996 9.53316C10.599 8.65885 10.8671 7.80546 11.3675 7.08849C11.8678 6.37152 12.5764 5.82558 13.3973 5.52455C14.2181 5.22351 15.1117 5.18193 15.9569 5.40542C16.8023 5.62889 17.5585 6.10666 18.1233 6.77405",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 18.7773H33.0005",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCobrancasIconWhite);
export default __webpack_public_path__ + "static/media/cobrancas-icon-white.422ce6812d922a1c1493b8b6bbd8683b.svg";
export { ForwardRef as ReactComponent };